import React  from 'react'


const Newsitem=(props)=> {
    

  
    let {title,description,url,newsurl,date,author,source,color} = props;
    return (
        <div className='my-3'>
            <div className="card" >
              <div style={{display:'flex', justifyContent:'flex-end',position:'absolute',left:0}}>
              <span className={` badge rounded-pill bg-${color} `}>
                          {source}
                        <span class="visually-hidden">unread messages</span>
                      </span>
                      </div>
                <img src={url? url : "https://c.ndtvimg.com/2023-09/ub05gdlc_jawan1200_625x300_13_September_23.jpg"} className="card-img-top" alt="..."/>
                <div className="card-body">
                    <h5 className="card-title">{title} 
                      
                    </h5>
                    <p className="card-text">{description? description : "Click To Read Full News"}</p>
                    <p class="card-text"><small className="text-body-secondary"> by {author} on {new Date(date).toGMTString()}</small></p>
                    <a href={newsurl} rel='noreferrer' target='_blank' className="btn btn-sm btn-dark">Read More</a>
                    
                </div>
            </div>
        </div>
    )
  }


export default Newsitem
